module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAtCAMAAAAX+PImAAAAPFBMVEUAAAA7tlM7tlM7tlM7tlM7tlM7tlM7tlM7tlM7tlM7tlM7tlM7tlM7tlM7tlM7tlM7tlM7tlM7tlM7tlO/7CP7AAAAE3RSTlMA6BCty3dFHgec8te8imRUNSmdIXexnAAAAINJREFUOMvt0ccRhDAQRNHWyOJhlX+uS1EgGJmJQO/8T91IIodHL3rRi2SIsgHBiIEJgFdCoDxOTigcLrYZWNx0I9B40FQNJkJyjJVgPPCxVYoNzFIECzJzFszIkeJTEQo7K3ZUrJ9gBVPe/ENdMO+hDV6lQ1vcfajAXoeKdNSQkSZwf3mvNBf5cKdHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/biaoge-green.png
// module id = 509
// module chunks = 0